import ApplyDialogBtnComponent from './ApplyDialogBtn.vue'
const ApplyDialogBtn = {
  install:function(Vue){
      Vue.component('ApplyDialogBtn',ApplyDialogBtnComponent)
  }
}
export default ApplyDialogBtn